import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RichText from '../RichText'
import { useStyles } from './FAQAccordion.styles'

const FAQAccordion = ({ faqs }) => {
  const styles = useStyles()
  return faqs.map((faqSubItem, faqSubItemIndex) => (
    <Accordion
      className={styles.accordion}
      key={`faqSubItemKey-${faqSubItemIndex}`}
    >
      <AccordionSummary
        className={styles.accordionSummary}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography variant="body1" className={styles.accordionSummaryTitle}>
          {faqSubItem.heading}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        {faqSubItem?.content?.raw && (
          <RichText
            variant="body1"
            document={JSON.parse(faqSubItem?.content?.raw)}
          />
        )}
      </AccordionDetails>
    </Accordion>
  ))
}
export default FAQAccordion
